<template>
    <div :class="mainculinaryclass" v-if="ticket.id>0 || isNewTicket">
        
        <Summary_Vertical panelIndex="0" @completetransaction="completetransaction" @setpanel="getsuspendedticketcount"/>
        <Summary_Vertical panelIndex="1" />
        <Summary_Vertical panelIndex="2" />


        <CulinaryPanel panelIndex="0" @refreshticket="refreshticketstart" ref="culinary" />
        <CartPanel_Culinary panelIndex="1" ref="cart" @refreshticket="refreshticket" @refreshticketrebuild="refreshticketrebuild"/>
        <PayPanel_Culinary panelIndex="2" ref="pay" @refreshticket="refreshticket" @refreshticketrebuild="refreshticketrebuild"  />

    </div>
  </template>
  
  <script>
  
  import {mapFields} from 'vuex-map-fields'
  import style from '../../style/style.js'
  import Summary_Vertical from "../screens/Summary_Vertical.vue";
  import PayPanel_Culinary from "../screens/PayPanel_Culinary.vue";
  import ActionPanel from "../screens/ActionPanel.vue";
  import HistoryPanel from "../screens/HistoryPanel.vue";
  import CulinaryPanel from '../screens/CulinaryPanel.vue'
  import CartPanel_Culinary from '../screens/CartPanel_Culinary.vue';
  import pos from '../../services/pos.js'
import pos_culinary from '../../services/pos_culinary.js'
  export default {
    name:'main_culinary',
      components:{
  

        CartPanel_Culinary,
          PayPanel_Culinary,
          ActionPanel,
          Summary_Vertical,
          HistoryPanel,
          CulinaryPanel,

      },
      mixins:[ style,pos,pos_culinary],
      computed:{
          ...mapFields([
              'isGoTo',
              'ticket'
   
          ]),
          mainculinaryclass(){
            if(this.inTestMode){return "mainculinarytest"}
            else{return "mainculinary"}
          },
      },
      data(){
          return{

          }
      },
      methods:{

        completetransaction(){
       
          this.$refs.pay.process_terminaltest()
        },

        

        async refreshticketstart(){
          this.isGoTo=false
          this.refreshticket(true)
        },
        refreshticketrebuild(msg){
          this.isGoTo=true
          this.refreshticket(false, msg)
        },
        
      }
      
     
      
  }
  </script>
  
  <style lang="scss">
  @import "@/assets/stylebase.scss";
  
  
  
  .mainculinary {
      grid-area: center;
      height:100%;
      background-color: var(--background-color);
  
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 60px auto;
      grid-template-areas:
        "guest cart payment"
        "full full full";
    }
  
  .mainculinarytest{
    grid-area: center;
      height:100%;
      background-color: var(--color-red);
  
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 60px auto;
      grid-template-areas:
        "guest cart payment"
        "full full full";
  }
  
 
  .guest {
    grid-area: guest;
  }
  .lineitem {
    grid-area: cart;
  }
  .action {
    grid-area: action;
  }
  .payment {
    grid-area: payment;
  }
  .history {
    grid-area: history;
  }
  
  /*PANELS*/
  .panel {
    border-radius: var(--border-radius-more);
    padding: var(--padding-default);
    background-color: var(--frame-color);
  }
  .panel-inactive {
    margin: 10px 20px 10px 10px;
  }
  .panel-active {
    margin: 10px -10px 10px 10px;
    border: var(--border-default);
    box-shadow: var(--box-shadow-default);
  }
  
  .panel-valid {
    border-style: solid;
    border-color: var(--color-valid);
    border-width: 0px 0px 0px 15px;
    /* puts green bar to left of tab */
  }
  .panel-invalid {
    background-color: var(--frame-color);
    border-color: var(--frame-color);
    border-width: 0px 0px 0px 15px;
  }
  .panel-unavailable {
    background-color: var(--background-color-disabled);
    color: var(--color-dark-blue); 
  }
  .panel-full-culinary {
    grid-area: full;
    background-color: var(--frame-color);
    margin: 10px 10px 10px 10px;
    padding: var(--padding-bigger);
    box-shadow: var(--box-shadow-default);
  }
  .panel-inner {
    padding: var(--padding-default);
    margin: var(--margin-default);
    border: var(--border-default);
    border-radius: var(--border-radius-default);
    // box-shadow: var(--box-shadow-smaller);
    //background-color: var(--background-color-inner);
  }
  .color-inner{
    //background-color: var(--background-color-inner);
    border: var(--border-default);
  }
  .color-highlight{
   // background-color: var(--background-color-inner);
    border: var(--border-thick);
    border-color:var(--button-color);
    //font-weight: bolder;
  }
  /* input:focus{
      border:1px solid var(--highlight-color);
      outline:none;
    } */
  .scroll{
    height:80%;
      overflow-x:hidden;
      overflow-y:scroll;
  }
  /*BUTTONS*/
  .btn {
    background-color: var(--button-color);
    color: var(--light-text-color);
    margin: var(--margin-default);
    border: none;
    font-size: inherit;
    border-radius: var(--border-radius-default);
    padding: var(--padding-bigger);
    
  }
  .btn-red{
    background-color:var(--color-red);
    color: var(--light-text-color);
    margin: var(--margin-default);
    border: none;
    font-size: inherit;
    border-radius: var(--border-radius-default);
    padding: var(--padding-smaller);
  }
  .btn-red-fixed{
    background-color:var(--color-red);
    color: var(--light-text-color);
    margin: var(--margin-default);
    border: none;
    font-size: inherit;
    border-radius: var(--border-radius-default);
    padding: var(--padding-smaller);
    // width:120px;
  }
  .btn-small {
    background-color: var(--button-color);
    color: var(--light-text-color);
    margin: var(--margin-default);
    border: none;
    font-size: inherit;
    border-radius: var(--border-radius-default);
    padding: var(--padding-smaller);
  }
  .btn:hover {
    background-color: var(--highlight-button-color);
  }
  .btn-small:hover {
    background-color: var(--highlight-button-color);
  }
  .paymentbutton {
    background-color: var(--color-payment);
    color: var(--light-text-color);
    min-width:120px;
  }
  .cashpaymentbutton{
    background-color: var(--color-cash);
    color: var(--light-text-color);
    min-width:120px;
  }
  .nextbutton {
    grid-area: next;
    text-align: right;
  }
  
  
  /*TEXT*/
  .text {
    margin: var(--margin-default);
    font-size: var(--font-size-default);
  }
  .title {
    margin: var(--margin-default);
    font-size: var(--font-size-bigger);
  }
  .subtitletab{
    font-size: var(--font-size-default);
  }
  .subtitletabalert{
    font-size: var(--font-size-default);
    color:var(--color-red);
  }
  .subtitle {
    font-size: var(--font-size-bigger);
  }
  .text-right {
    text-align: right;
  }
  .bold {
    font-weight: bold;
  }
  hr {
    color: var(--inactive-color);
  }
  
  /*IMAGES*/
  .headerimage {
    width: 50%;
    margin: var(--margin-bigger);
  }
  
  /*TEXTBOXES*/
  .textbox {
    font-size: inherit;
    margin: var(--margin-default);
    border-radius: var(--border-radius-default);
  }
  
  /*TABLES*/
  table,
  th,
  td {
    border: var(--border-default);
    padding: var(--padding-default);
    font-weight: normal;
  }
  td {
    text-align: center;
  }
  th {
    font-size: var(--font-size-bigger);
  }
  table {
    border-collapse: collapse;
    margin: var(--margin-default);
    width: 92%;
  }
  
  
  .totaltext{
    font-size:larger;
    
  }
  .paycolor{
    color:var(--color-payment);
    font-weight:bold;
  }
  .discountcolor{
    color:var(--color-red);
  }
  .eligiblemessage{
    color:var(--color-payment);
  }
  
  </style>